import React from 'react';
import * as S from './PlaylistCard.style';
export const PlaylistCard = ({ imgUrl, playlistName, owner, link }) => (React.createElement(S.PlaylistCard, null,
    React.createElement(S.PlaylistCardFigure, null,
        React.createElement(S.PlaylistCardImg, { src: imgUrl, alt: playlistName, loading: 'lazy' })),
    React.createElement(S.Footer, null,
        React.createElement(S.PlaylistInfo, null,
            React.createElement(S.PlaylistInfoTitle, null, playlistName),
            React.createElement(S.PlaylistInfoSubtitle, null,
                "por ",
                owner)),
        React.createElement(S.Link, { href: link, rel: 'noreferrer', target: '_blank' }, "Escutar"))));
//# sourceMappingURL=PlaylistCard.js.map